import cn from 'classnames';
import styles from "./checkbox.module.scss";
import { useContext } from 'react';
import { StylesContext } from '../../../contexts/styles-context/styles.context';

export interface ICheckboxProps {
  checked: boolean;
  multiple: boolean;
  defaultChecked?: boolean;
}

export function Checkbox({ checked, multiple, defaultChecked }) {
  const { styles: customStyles = {} } = useContext(StylesContext);
  
  return <div 
    className={cn(multiple ? styles.checkbox : styles.radio, { [styles.active]: checked, [styles.defaultChecked]: defaultChecked })}
    style={checked ? customStyles.checkedAnswerCheckbox as any : {}}
  ></div>
}